import { jwtDecode } from "jwt-decode";

export const decodeJwtTokenPayload = token => 
{
  
    let decodedValue = jwtDecode(token, {payload:true});
    
    return decodedValue;
}

export const getUserRoleArr = token => 
{   
    let resultArr = [];
    let decodedValue = jwtDecode(token, {payload:true});
    if(decodedValue !== null){
        let personel= JSON.parse(decodedValue.Personel)
        resultArr = personel.Roles;
       
    } 
    return resultArr;
}